import { Component } from "@angular/core";
import { TooltipAnchor } from "@ui";

@Component({
  selector: "app-column-type-instructions-tooltip",
  template: `
    <p-tooltip-anchor [tooltip]="instructions" tooltipClass="p-tooltip--column-type-instructions" />
    <ng-template #instructions>
      <div class="p-tooltip__column-type-instructions p-flex-col-sm p-text-footnote">
        <span>Specify the type of each column in data set using the drop down menus.</span>
        <div class="p-flex-col-xs">
          <span><strong>Text:</strong> Any text content.</span>
          <span><strong>Category:</strong> Categorical labels, such as "Blue" and "Green".</span>
          <span><strong>Integer:</strong> Integer numbers such as -3 and 7.</span>
          <span><strong>Float:</strong> Floating point numbers such as -3.65 and 9.33.</span>
          <span><strong>Date:</strong> A date, time, or date-time. Use the button beside the drop-down to set its format.</span>
          <span><strong>Boolean:</strong> The values "true" and "false".</span>
        </div>
      </div>
    </ng-template>
  `,
  styles: [
    `
      ::ng-deep .p-tooltip--column-type-instructions {
        text-align: left !important;
      }

      ::ng-deep .p-tooltip--column-type-instructions .p-tooltip__column-type-instructions {
        color: var(--p-color-gray-100);
      }
    `,
  ],
  imports: [TooltipAnchor],
})
export class ColumnTypeInstructionsTooltipComponent {}
